import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "item profile"
}
const _hoisted_2 = { class: "autoSpan" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileAvatarComponent = _resolveComponent("ProfileAvatarComponent")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ProfileAvatarComponent, {
          class: "small",
          badges: false,
          border: true,
          profileImage: _ctx.getUserProfilePicture(_ctx.user)
        }, null, 8, ["profileImage"]),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.user.fullName) + " ", 1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.user.userName), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}